import { TabPanel, Tabs } from '@paypalcorp/pp-react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import CodeWrapper from './CodeWrapper';
import styles from './IntegrationPageSection.module.less';
import ExpandablePreview from './PreviewWrapper/ExpandablePreview';
import AppSwitch from './AppSwitch';
import IntegrationPageSectionContext from './StateManagement/IntegrationPageSectionContext';

export default function TabbedLayout({
  selectedTabIdx,
  handleTabSelect,
  prevScroll,
  expandedMode,
  tabs
}) {
  const {
    code: { language: { frontend } = {} },
    appSwitch
  } = useContext(IntegrationPageSectionContext);

  const tabsList = Object.values(tabs).filter(
    (tab) =>
      !(tab.id === 'app_switch' && (!appSwitch || !tab.eligible_languages?.includes(frontend)))
  );
  useEffect(() => {
    if (!appSwitch) {
      handleTabSelect(null, 0); // reset tab if appSwitch disabled
    }
  }, [appSwitch]);
  return (
    <Tabs
      name="IntegrationTabs"
      className={cx([styles.tabs, { [styles.tabs_expanded]: expandedMode }])}
      selectedTabIdx={selectedTabIdx}
      tabs={tabsList}
      onClick={handleTabSelect}
      keepAlive
    >
      <TabPanel
        id={tabs.preview.panelId}
        tabId={tabs.preview.panelId}
        className={styles.tabs_wrapper}
      >
        <ExpandablePreview expandedMode={expandedMode} prevScroll={prevScroll} />
      </TabPanel>
      <TabPanel id={tabs.code.panelId} tabId={tabs.code.panelId} className={styles.tabs_wrapper}>
        <CodeWrapper />
      </TabPanel>
      {appSwitch && (
        <TabPanel
          id={tabs.app_switch.panelId}
          tabId={tabs.app_switch.panelId}
          className={styles.tabs_wrapper}
        >
          <AppSwitch config={tabs.app_switch.gif_config} />
        </TabPanel>
      )}
    </Tabs>
  );
}

TabbedLayout.propTypes = {
  selectedTabIdx: PropTypes.number.isRequired,
  handleTabSelect: PropTypes.func.isRequired,
  prevScroll: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]).isRequired,
  expandedMode: PropTypes.bool.isRequired
};
